<template>
  <c-preview
    v-bind="$attrs"
    v-on="$listeners"
    @click.native.prevent
  >
    <template #preview-extra-button>
      <slot name="preview-extra-button" />
    </template>
  </c-preview>
</template>

<script>
import CPreview from '@convenia/components/CPreview'

export default {
  name: 'CPreviewFragment',
  components: {
    CPreview
  }
}
</script>
